import React, { useState, useRef, useEffect } from 'react'
import {
  DashboardOutlined,
  AppstoreOutlined,
  AntDesignOutlined,
  FileTextOutlined,
  SearchOutlined,
} from '@ant-design/icons'
import { Link } from 'react-router-dom'
import { AutoComplete, Input } from 'antd'
import IntlMessage from 'components/util-components/IntlMessage'
import navigationConfig from 'configs/NavigationConfig'
import Flex from 'components/shared-components/Flex'

function getOptionList(navigationTree, optionTree, category) {
  optionTree = optionTree || []
  for (const navItem of navigationTree) {
    const itemCategory = category ?? navItem.key
    if (navItem.submenu.length === 0) {
      optionTree.push({ ...navItem, _category: itemCategory })
    }
    if (navItem.submenu.length > 0) {
      getOptionList(navItem.submenu, optionTree, itemCategory)
    }
  }
  return optionTree
}

const optionList = getOptionList(navigationConfig)

const getCategoryIcon = (category) => {
  switch (category) {
    case 'dashboards':
      return <DashboardOutlined className="text-success" />
    case 'apps':
      return <AppstoreOutlined className="text-danger" />
    case 'components':
      return <AntDesignOutlined className="text-primary" />
    case 'pages':
    case 'admins':
    case 'extra':
      return <FileTextOutlined className="text-warning" />
    default:
      return <FileTextOutlined className="text-muted" />
  }
}

const searchResult = (mode) =>
  optionList.map((item) => {
    const category = item._category
    return {
      value: item.path,
      label: (
        <Link to={item.path}>
          <Flex alignItems="center" className="search-list-item">
            <div className="search-list-item-icon">{getCategoryIcon(category)}</div>
            <div
              className={`font-weight-semibold search-list-item-title ${
                mode === 'light' ? 'search-list-item-title-light' : ''
              }`}
            >
              <IntlMessage id={item.title} />
            </div>
          </Flex>
        </Link>
      ),
    }
  })

const SearchInput = (props) => {
  const { active, close, isMobile, mode } = props
  const [value, setValue] = useState('')
  const [options, setOptions] = useState([])
  const inputRef = useRef(null)

  const onSelect = () => {
    setValue('')
    setOptions([])
    if (close) {
      close()
    }
  }

  const onSearch = (searchText) => {
    setValue(searchText)
    setOptions(!searchText ? [] : searchResult(mode))
  }

  useEffect(() => {
    if (active) {
      inputRef.current?.focus?.()
    }
  }, [active])

  return (
    <AutoComplete
      ref={inputRef}
      className={`nav-search-input nav-search-input--${mode} ${
        isMobile ? 'is-mobile' : ''
      }`}
      classNames={{ popup: { root: 'nav-search-dropdown' } }}
      options={options}
      onSelect={onSelect}
      onSearch={onSearch}
      value={value}
      filterOption={(inputValue, option) =>
        option.value.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
      }
    >
      <Input
        placeholder="Search..."
        prefix={<SearchOutlined className="mr-0" />}
        variant="borderless"
      />
    </AutoComplete>
  )
}

export default SearchInput
